module.exports = __webpack_public_path__ + "cc.4362c7e71a72bb7ba720.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cc.svg
// module chunks = styles